// extracted by mini-css-extract-plugin
export var item = "WrapList-module--item--1a6b9";
export var root = "WrapList-module--root--06519";